import { render, staticRenderFns } from "./adminEditCategory.vue?vue&type=template&id=4291c074&scoped=true&lang=html&"
import script from "./adminEditCategory.vue?vue&type=script&lang=js&"
export * from "./adminEditCategory.vue?vue&type=script&lang=js&"
import style0 from "./adminEditCategory.vue?vue&type=style&index=0&id=4291c074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4291c074",
  null
  
)

export default component.exports